module.exports = __webpack_public_path__ + "static/assets/158870032ca2f16b15860ca3f3276c37.svg";